import styled from 'styled-components';
import { theme } from '../../styles/theme';

export interface CardProps {
  children: React.ReactNode;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: 'sm' | 'md' | 'lg' | 'xl';
  hover?: boolean;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const StyledCard = styled.div<CardProps>`
  background-color: ${theme.colors.background};
  border-radius: ${theme.borderRadius.lg};
  border: 1px solid ${theme.colors.border};
  transition: all ${theme.transitions.normal};
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  
  ${({ padding = 'md' }) => {
    switch (padding) {
      case 'sm':
        return `padding: ${theme.spacing.md};`;
      case 'lg':
        return `padding: ${theme.spacing.xl};`;
      default:
        return `padding: ${theme.spacing.lg};`;
    }
  }}

  ${({ shadow = 'sm' }) => `box-shadow: ${theme.shadows[shadow]};`}

  ${({ hover }) => hover && `
    &:hover {
      transform: translateY(-4px);
      box-shadow: ${theme.shadows.lg};
    }
  `}
  
  @media (max-width: ${theme.breakpoints.md}) {
    ${({ padding = 'md' }) => {
      switch (padding) {
        case 'sm':
          return `padding: ${theme.spacing.sm};`;
        case 'lg':
          return `padding: ${theme.spacing.lg};`;
        default:
          return `padding: ${theme.spacing.md};`;
      }
    }}
  }
  
  @media (max-width: ${theme.breakpoints.sm}) {
    border-radius: ${theme.borderRadius.md};
    
    ${({ padding = 'md' }) => {
      switch (padding) {
        case 'sm':
          return `padding: ${theme.spacing.md};`;
        case 'lg':
          return `padding: ${theme.spacing.lg};`;
        default:
          return `padding: ${theme.spacing.lg};`;
      }
    }}
  }
`;

export const Card: React.FC<CardProps> = ({ children, onClick, style, ...props }) => {
  return <StyledCard {...props} onClick={onClick} style={style}>{children}</StyledCard>;
};
